import React from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';

import { orderListLoad } from 'store/models/order';
import { FormItem } from 'utils';
import { ListLoadComponent } from 'components/common';

const OrderSelect = (props) => {
  return (
    <ListLoadComponent
      apiLoad={orderListLoad(props.site.activeDomain)}
      {...props}
      render={({ items }) => {
        const { onChange, disabled, router, authToken, model, dispatch, activeFilter, ...otherProps } = props;
        return (
          <FormItem {...otherProps}>
            <Select
              style={{ width: '100%' }}
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder="Выберите"
              showSearch={true}
              allowClear={true}
              disabled={disabled}
              filterOption={(input, option) => {
                const children = option.props.children;
                return children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }}
            >
              {!otherProps.required && <Select.Option value={null}>---</Select.Option>}
              {items.map(item => (
                <Select.Option key={`order${item.id}`} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </FormItem>
        );
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.order,
  site: state.site,
});

export default connect(mapState)(OrderSelect);
